import { type EditorType } from '@heidi/editor/core';
import { type ReactNode } from 'react';
import { EditorTypeContext, EmphasisDisabledContext } from './editor-type';

/**
 * Exposes the host editor's `EditorType` (note vs template) to the markdown
 * editor subtree — including ReactNodeView portals such as the section node —
 * so section analytics can report which editor an action happened in without
 * prop-drilling through ProseMirror's render boundary.
 */
export function EditorTypeProvider({
  editorType,
  emphasisDisabled = false,
  children,
}: {
  editorType?: EditorType;
  emphasisDisabled?: boolean;
  children: ReactNode;
}) {
  return (
    <EditorTypeContext.Provider value={editorType}>
      <EmphasisDisabledContext.Provider value={emphasisDisabled}>
        {children}
      </EmphasisDisabledContext.Provider>
    </EditorTypeContext.Provider>
  );
}
